import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICompaniesService } from "services/CompaniesService";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  companyId: undefined as undefined | string,
  failed: false,
  loading: false,
};

const companyProviderSlice = createSlice({
  name: "companyLoader",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyFromHost.fulfilled, (state, action) => {
        state.companyId = action.payload;
        state.loading = false;
      })
      .addCase(getCompanyFromHost.rejected, (state) => {
        state.companyId = undefined;
        state.failed = true;
        state.loading = false;
      })
      .addCase(getCompanyFromHost.pending, (state) => {
        state.loading = true;
      });
  },
});

export const getCompanyFromHost = createAsyncThunk("companyLoader/getCompanyFromHost", async (host: string) => {
  const companiesService = container.get<ICompaniesService>(SERVICE_TYPES.CompaniesService);
  return await companiesService.getCompanyIDFromHost(host);
});

export const selectCompanyId = (state: RootState) => state.companyProvider.companyId;
export const selectFailed = (state: RootState) => state.companyProvider.failed;
export const selectLoading = (state: RootState) => state.companyProvider.loading;

export default companyProviderSlice.reducer;
